import React, { useState, useContext } from 'react'
import classNames from 'classnames'
import { Link, useHistory } from 'react-router-dom'
import { bool, func } from 'prop-types'
import { useTranslation } from 'react-i18next'
import SugarcubeContext from 'apps/SugarcubeContext'
import SidepanelMenuContainer from 'containers/designSidepanel/SidepanelMenuContainer'
import SidepanelBody from 'components/designSidepanel/SidepanelBody'
import { sidepanelTabsType } from 'models/propTypes'

import Icon from 'components/uiElements/Icon'
import Tooltip from 'components/Tooltip'
import SkipLinks from 'components/SkipLinks'
import { BROWSE, DESIGN, HEADER, NAVIGATION } from 'components/SkipLinks/constants'

require('./Sidepanel.scss')

const Sidepanel = ({
    isOpen: isPinned,
    close,
    open,
    showFilterModal,
    designingEnabled,
    openDesignLab,
    selectedTabs,
}) => {
    const { t } = useTranslation()
    const [isHovered, setIsHovered] = useState(false)
    const { hideDashboard, isMobile, ikeaNav, isKiosk } = useContext(SugarcubeContext)
    const history = useHistory()

    const onHover = () => {
        if (!isMobile && designingEnabled) {
            setIsHovered(true)
        }
    }
    const onBlur = () => setIsHovered(false)
    const onToggle = () => {
        if (isPinned) {
            onBlur()
            close()
        } else {
            open()
        }
    }

    const onKiosk = () => {
        history.push(`/dashboard`)
    }

    const isHoverOpened = !isMobile && isHovered && !isPinned
    const showChevronIcon = !isMobile && !isKiosk

    return (
        <div className={classNames('Sidepanel', { isPinned, isHovered, designingEnabled, mobile: isMobile })}>
            <SkipLinks skipLinks={[BROWSE, DESIGN, NAVIGATION]} skipContext={HEADER} />

            <div className="hoverTrigger" onMouseEnter={onHover} />
            <div
                className={classNames('sidepanelContent', { mobile: isMobile })}
                onMouseEnter={onHover}
                onMouseLeave={onBlur}
            >
                {!isMobile && (
                    <div className="logoWrapper">
                        {ikeaNav ? (
                            <>
                                <Icon svg code="logo_ikea" className="logoHome" />
                                {!hideDashboard && (
                                    <button className="designLab" onClick={openDesignLab}>
                                        <Icon code="arrow_back" svg />
                                        {t('design.back to design lab')}
                                    </button>
                                )}
                                {isKiosk && (
                                    <button className="toKiosk" onClick={onKiosk}>
                                        <Icon code="arrow_back" svg />
                                        {t('kiosk.choose a room')}
                                    </button>
                                )}
                            </>
                        ) : (
                            <Link to="/dashboard" className="logoContainer">
                                <img
                                    src={`${ASSET_BUCKET}/logo_sugarcube_bug_ikea.svg`}
                                    alt={t('common.alt.logo')}
                                    className="logo"
                                />
                                <Icon svg code="home" className="logoHome" />
                            </Link>
                        )}
                    </div>
                )}
                {!isMobile && (
                    <div className="menu">
                        <SidepanelMenuContainer />
                    </div>
                )}
                <div className={classNames('sidepanelInner', { mobile: isMobile })}>
                    <SidepanelBody onToggle={onToggle} selectedTabs={selectedTabs} />
                </div>
            </div>
            {!isMobile && <Tooltip id="sidepanel-body-chevron" />}
            {showChevronIcon && !showFilterModal && (
                <div
                    className={classNames('close', { designingEnabled })}
                    onClick={onToggle}
                    data-for="sidepanel-body-chevron"
                    data-tip={isPinned ? t('tooltip.auto hide') : t('tooltip.keep expanded')}
                    data-testid="sidepanel-chevron-btn"
                    onMouseEnter={isHoverOpened ? onHover : null}
                    onMouseLeave={isHoverOpened ? onBlur : null}
                >
                    <Icon code="chevronRight" className="unpinned" />
                    <Icon code="chevronLeft" className="pinned" />
                    <Icon code="pin" className="pin" />
                </div>
            )}
            {isMobile && <div className={classNames('scrollCover')} />}
        </div>
    )
}

Sidepanel.propTypes = {
    isOpen: bool.isRequired,
    close: func.isRequired,
    open: func.isRequired,
    showFilterModal: bool.isRequired,
    designingEnabled: bool.isRequired,
    openDesignLab: func.isRequired,
    selectedTabs: sidepanelTabsType.isRequired,
}

export default Sidepanel
